import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import {
	SUB_LOCATIONS,
	SUB_LOCATIONS_ADD,
	SUB_LOCATIONS_ROW_DATA,
	SUB_LOCATIONS_DELETE,
} from "./actionTypes";
import {
	apiError,
	getSubLocations,
	SublocationListSuccessful,
	locationRowDataSuccessful,
	locationAddSuccessful,
} from "./actions";

// AUTH related methods
import {
	postAdd,
	getList,
	getParamsList,
	postEdit,
	postDelete,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getSubLocation({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "") {
					params[k] = data[k];
				}
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/masters/sublocations/",
			params
		);
		yield put(SublocationListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* SubLocationRowData({ payload: { LocId } }) {
	try {
		const response = yield call(
			getList,
			"/masters/sublocations/" + LocId,
			{}
		);
		yield put(
			locationRowDataSuccessful({
				response: {
					...response,
					locationsLabel: response.location
						? response.location.name
						: "",
					location_id: response.location ? response.location.id : "",
					costCenterType: response.cost_center_type_name
						? response.cost_center_type_name
						: "",
					costCenterId: response.cost_center_type
						? response.cost_center_type
						: "",
				},
			})
		);
	} catch (error) {
		yield put(apiError(error));
	}
}
//If user is login then dispatch redux action's are directly from here.
function* AddSubLocation({ payload: { data } }) {
	try {
		if (data.id == null) {
			const response = yield call(
				postAdd,
				"/masters/sublocations/",
				data
			);
			if (response.status === 201) {
				swal("Your Sub Location Added Successfully.!", {
					icon: "success",
					timer: 1500,
				});
				yield put(getSubLocations());
			} else {
				swal("Sorry! Unable to added Sub Location. Please Try Again!", {
					icon: "error",
				});
			}
			yield put(locationAddSuccessful(null));
		} else {
			const response = yield call(
				postEdit,
				"/masters/sublocations/" + data.id,
				data
			);
			if (response.status === 200) {
				swal("Your Sub Location Edited Successfully.!", {
					icon: "success",
					timer: 1500,
				});
				yield put(getSubLocations());
			} else {
				swal("Sorry! Unable to edit Sub Location. Please Try Again!", {
					icon: "error",
				});
			}
			yield put(locationAddSuccessful(null));
		}
	} catch (err) {
		console.error("PUTIMG ERROR:", err);

		let backendData =
			err?.response?.data || // axios error
			err; // plain object error (your case)

		let message = "Something went wrong";
		console.log(backendData, "backendData");
		// If backend returned object like {name: ['error']}
		if (backendData && typeof backendData === "object") {
			const firstKey = Object.keys(backendData)[0];
			const firstValue = backendData[firstKey];

			if (Array.isArray(firstValue)) {
				message = firstValue[0];
			} else if (typeof firstValue === "string") {
				message = firstValue;
			}
		}

		swal(message, { icon: "error", timer: 2000 });
		return;
	}
}

//If user is login then dispatch redux action's are directly from here.
function* DeleteLocation({ payload: { locId } }) {
	try {
		const response = yield call(
			postDelete,
			"/masters/sublocations/" + locId
		);

		if (response.status === 204) {
			swal(" Your Sub Location has been deleted!", {
				icon: "success",
				timer: 1500,
			});
			yield put(getSubLocations());
		} else {
			swal("Sorry! Your Sub Location has been not deleted!", {
				icon: "error",
			});
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}

export function* watchgetSubLocations() {
	yield takeEvery(SUB_LOCATIONS, getSubLocation);
}
export function* watchSubLocationAdd() {
	yield takeEvery(SUB_LOCATIONS_ADD, AddSubLocation);
}
export function* watchSubLocationRowData() {
	yield takeEvery(SUB_LOCATIONS_ROW_DATA, SubLocationRowData);
}

export function* watchLocationDelete() {
	yield takeEvery(SUB_LOCATIONS_DELETE, DeleteLocation);
}

function* SubLocationSaga() {
	yield all([
		fork(watchgetSubLocations),
		fork(watchSubLocationAdd),
		fork(watchSubLocationRowData),
		fork(watchLocationDelete),
	]);
}

export default SubLocationSaga;
